import { apiConfig } from '@constants';

import { platformName } from '../../helpers/Platform';

export const getSegmentWriteKey = () => {
  const platform = platformName() ?? 'browser';

  switch (platform) {
    case 'FireTV':
      return apiConfig.FIRE_SEGMENT_WRITE_KEY;
    case 'GoogleTV':
      return apiConfig.GOOGLE_SEGMENT_WRITE_KEY;
    case 'Samsung':
      return apiConfig.SAMSUNG_SEGMENT_WRITE_KEY;
    case 'X1':
      return apiConfig.X1_SEGMENT_WRITE_KEY;
    case 'Vizio':
      return apiConfig.VIZIO_SEGMENT_WRITE_KEY;
    case 'browser':
      return null;
    default:
      return null;
  }
};
